import { render, staticRenderFns } from "./ExtraordinarySitting.vue?vue&type=template&id=22cb1ca0&scoped=true&"
import script from "./ExtraordinarySitting.vue?vue&type=script&lang=js&"
export * from "./ExtraordinarySitting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb1ca0",
  null
  
)

export default component.exports